import {Injectable} from "@angular/core";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ComponentType} from "@angular/cdk/overlay";

@Injectable({
  providedIn: 'root',
})
export class DialogService<T> {

  dialog: MatDialog;

  constructor(dialog: MatDialog) {
    this.dialog = dialog;
  }

  open(component: ComponentType<T>, config?: MatDialogConfig) {
    this.dialog.open(component, config);
  }
}
